module.exports = __webpack_public_path__ + "static/media/to.7bd331f3.svg";